// extracted by mini-css-extract-plugin
export default {"preview":"ezb82"};